import React, { useEffect, useState } from 'react';
import classes from "./History.module.css";
import Header from '../components/Header';
import BottomNavbar from '../components/BottomNavbar';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getHistory } from '../http/http';
import { findLevel } from '../utils/levels';
import moment from 'moment';
import { FaArrowLeft } from "react-icons/fa6";
import MediumLoader from '../components/Loaders/MediumLoader';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';

const History = () => {
    const [historyList, setHistoryList] = useState([]);
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const { selectedLanguage } = useSelector(state => state.languageSlice);
    const dispatch = useDispatch();

    const getUserHistory = async () => {
        try {
            setLoading(true);
            const response = await getHistory(userToken);
            setLoading(false);
            setHistoryList(response?.data?.result);
        } catch (error) {

            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        if (userToken) {
            getUserHistory();
        }
        else {
            navigate("/")
        }
    }, [userToken]);

    return (
        <>
            <Header />

            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate(-1);
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("32")}</h2>
                </div>

                <div className={classes.quizes_list}>
                    {loading ? <MediumLoader /> : historyList?.map((quiz, idx) => {
                        return (
                            <div className={classes.quiz_item} key={idx} onClick={() => navigate("/quiz-details", {
                                state: quiz
                            })}>
                                <div className={classes.quiz_image}>
                                    <img className={classes.quiz_img} src={quiz?.quiz_name == "YaMo Quiz" ? "/assets/images/mtn_yamo_logo.jpeg" : quiz?.quiz_name == "Reverse Quiz" ? "/assets/images/reverse_quiz.svg" : quiz?.quiz_image ? quiz?.quiz_image : "/assets/images/download.png"} alt={quiz?.quizName} />
                                </div>
                                <div className={classes.quiz_description_container}>
                                    <p className={classes.quiz_name}>{quiz?.quiz_name}</p>
                                    <p className={classes.quiz_description}>{t("33")} {quiz?.level_id}</p>
                                    <p className={classes.quiz_description}>{t("18")} {quiz?.points}</p>
                                </div>
                                <p className={classes.date_time}>
                                    {moment(quiz?.createdAt).format("YYYY-MM-DD")}
                                </p>
                            </div>
                        )
                    })}
                </div>
            </div>
            <BottomNavbar active={4} />
        </>
    )
}

export default History